import {Component, Input, OnDestroy, OnInit, ViewEncapsulation} from '@angular/core';
import {takeWhile} from 'rxjs/operators';
import {DataCacheApiService} from '../../../services/map/data-cache-api/data-cache-api.service';
import * as _ from 'lodash';

@Component({
  selector: 'peer-connection-aggregation-summary',
  templateUrl: './peer-connection-aggregation-summary.component.html',
  styleUrls: ['./peer-connection-aggregation-summary.component.less'],
  encapsulation: ViewEncapsulation.None
})
export class PeerConnectionAggregationSummaryComponent implements OnInit {

  @Input()
  set selection(selection: any) {
    this.dataInitialization(selection);
  }

  constructor(private dataCacheApiService: DataCacheApiService) {}

  cluster: any;
  isQualityEnabled: boolean;
  dataReady = false;

  ngOnInit(): void {
    this.dataCacheApiService.getDataReady().pipe(takeWhile(() => this.dataReady === false)).
    subscribe(x => {
      if (x === true) {
        this.dataReady = true;
        this.initializeQualityBasedRoutingConfigurations();
      }
    });
  }

  initializeQualityBasedRoutingConfigurations(): void {
    this.isQualityEnabled = this.dataCacheApiService.getQualityBasedRouting().isQualityEnabled;
  }

  numberOfClusterEdges(numberOfEdges: number): any {
    return numberOfEdges >= 99 ? '99+' : numberOfEdges;
  }

  private dataInitialization(selection: any): void {
    if (_.isNil(selection)) { return; }

    const shapes = selection.nodes;
    const connections = selection.edges;
    if (shapes.length === 0 && connections.length === 1 && connections[0].connectionType === 'cluster') {
      this.cluster = connections[0];
    }
  }
}
